import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
/**
 * Utility function to merge Tailwind CSS classes
 * Combines clsx for conditional classes and tailwind-merge for deduplication
 *
 * @param inputs - Class values to merge
 * @returns Merged class string
 *
 * @example
 * cn('px-2 py-1', 'px-4', { 'text-red-500': isError })
 * // Returns: 'py-1 px-4 text-red-500' (if isError is true)
 */
export function cn(...inputs) {
    return twMerge(clsx(inputs));
}
